"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = isLowEndExperience;

var _getNetworkInformation = _interopRequireDefault(require("./getNetworkInformation"));

var _isLowEndDevice = _interopRequireDefault(require("./isLowEndDevice"));

function isLowEndExperience() {
  if ((0, _isLowEndDevice.default)()) {
    return true;
  }

  var connection = (0, _getNetworkInformation.default)(); // If network connection is not available result is inconclusive.

  if (connection == null) {
    return false;
  } // If the effective type of the connection meaning
  // one of 'slow-2g', '2g', '3g', or '4g' is !== 4g


  if (['slow-2g', '2g', '3g'].indexOf(connection.effectiveType) !== -1) {
    return true;
  } // Data Saver preference


  if (connection.saveData) {
    return true;
  }

  return false;
}